import React from 'react';
import { CircularProgress, Typography, Box, Fade } from '@mui/material';

/**
 * Loading component for displaying loading state with modern animations
 * @param {Object} props - Component props
 * @param {String} props.message - Loading message
 * @param {Object} props.style - Additional style properties
 * @returns {JSX.Element} Loading component
 */
const Loading = ({ message = 'Loading...', style = {} }) => {
  return (
    <Fade in={true} timeout={300}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        padding={4}
        sx={{
          ...style,
          animation: 'fadeIn 0.3s ease-out',
        }}
      >
        <CircularProgress 
          size={48} 
          color="primary" 
          sx={{ 
            marginBottom: 2,
            animation: 'spin 0.8s linear infinite',
          }} 
        />
        <Typography 
          variant="body2" 
          color="textSecondary"
          sx={{
            fontWeight: 500,
            letterSpacing: '0.01em',
          }}
        >
          {message}
        </Typography>
      </Box>
    </Fade>
  );
};

export default Loading;
